import { render } from "./BeneficiaryProfile.vue?vue&type=template&id=919ec412&ts=true"
import script from "./BeneficiaryProfile.vue?vue&type=script&lang=ts"
export * from "./BeneficiaryProfile.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__